import { createContext } from "react";
import { AuthenticateType } from "../Types/AuthenticateType";



export const authContext = createContext<AuthenticateType>({} as AuthenticateType); 
